<template>
  <v-layout wrap>
    <v-flex xs12 text-xs-center>
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step
            @click="setStepper(1)"
            step="1"
            edit-icon="person"
            complete-icon="email"
            editable
            >Select Products</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step @click="setStepper(2)" step="2" editable offset-xs-6
            >Save Template</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout wrap>
              <v-flex xs12 sm8>
                <products-table
                  :headers="productTableHeaders"
                  :actions="productTableActions"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-card class="ml-2 elevation-0">
                  <v-card-title>Template Items</v-card-title>
                  <v-list three-line>
                    <v-list-item
                      three-line
                      v-for="(item, index) in template.items"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{
                          item.productCode
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.manufacturer
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{
                          item.category.name
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{
                          item.description[0].value
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon @click="removeItem(item)">
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-list-item v-if="!template.items.length">
                      <v-list-item-content>
                        <v-list-item-title
                          >No items have been added to this
                          template.</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="template.name"
                  outlined
                  dense
                  label="Template Name"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="template.description"
                  outlined
                  dense
                  label="Template Description"
                />
              </v-flex>
            </v-layout>
          </v-stepper-content>

          <v-layout pb-4 pr-4 pl-4>
            <v-flex v-if="currentStep > 1" sm12 text-sm-left>
              <v-btn @click="previousStep" color="primary">Back</v-btn>
            </v-flex>
            <v-flex v-if="currentStep < 2" sm12 text-sm-right>
              <v-btn @click="nextStep" color="primary">Continue</v-btn>
            </v-flex>
            <v-flex
              v-if="currentStep === 2 || currentStep === '2'"
              sm12
              text-sm-right
            >
              <v-btn
                @click="saveTemplate"
                :disabled="invalidTemplate"
                color="primary"
                >Submit</v-btn
              >
            </v-flex>
          </v-layout>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import Table from "@/components/Table";
import request from "@/modules/request";
import stepperMixin from "../../../mixins/stepperMixin";
import { get } from "lodash";
import ProductsTable from "@/components/ProductsTable";

export default {
  name: "UserCreateTemplate",
  mixins: [stepperMixin],
  inject: ["reactiveInjected", "snackBar"],
  components: {
    ProductsTable,
  },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      products: [],
      templateFor: null,
      template: {
        name: null,
        description: null,
        items: [],
        company: null,
        generalTemplate: false,
      },
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      productTableActions: [
        {
          color: "primary",
          click: this.addItem,
          text: "",
          icon: "add",
        },
      ],
      selectedTableActions: [
        {
          color: "error",
          click: this.removeItem,
          text: "",
          icon: "delete",
        },
      ],
      selectedTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "",
          value: "action",
        },
      ],
    };
  },
  computed: {
    invalidTemplate() {
      const { template } = this;
      return (
        !template.name ||
        !template.description ||
        !template.items.length ||
        !this.templateFor
      );
    },
  },
  methods: {
    addItem(item) {
      const added = this.template.items.find(
        (product) => product._id === item._id
      );
      if (!added) {
        this.template.items.push(item);
        this.snackBar("Item added", "success");
      } else {
        this.snackBar("Item already added", "error");
      }
    },
    removeItem(item) {
      this.template.items = this.template.items.filter(
        (product) => product._id !== item._id
      );
    },
    async getProducts() {
      const company = get(this, "reactiveInjected.activeUser.company");
      return request
        .callInternal({
          method: "get",
          route: `/api/products?company=${company}`,
        })
        .then((results) => {
          return results.data.docs;
        })
        .catch((error) => {
          console.error(error);
          return error;
        });
    },
    async loadData() {
      const { getProducts } = this;
      const results = await Promise.all([getProducts()])
        .then((results) => {
          return results;
        })
        .catch((error) => {
          console.error(error);
        });

      const [products] = results;
      this.products = products;
      this.currentStep = 1;
      this.template = {
        name: null,
        description: null,
        items: [],
        company: null,
        generalTemplate: null, // should equal companyId
      };
      this.templateFor = this.reactiveInjected.activeUser.company; // should equal companyId
    },
    async saveTemplate() {
      const { template, templateFor } = this;
      template.generalTemplate = false;
      template.company = templateFor;
      template.items = template.items.map((item) => item._id);
      await request
        .callInternal({
          method: "post",
          route: "/api/template",
          data: template,
        })
        .then(() => {
          this.$swal({
            title: "Congratulations!",
            text: `Template ${template.name} has been added.`,
            icon: "success",
          });
          this.loadData();
        })
        .catch((error) => {
          console.error(error);
          this.$swal({
            title: "Error",
            text: `Sorry, something went wrong with adding ${template.name}. Please try again or contact your system administrator.`,
            icon: "error",
          });
        });
    },
  },
};
</script>
